import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../assets/images/user/user3.jpg'
import _imports_1 from '../../../assets/images/user/user1.jpg'
import _imports_2 from '../../../assets/images/user/user4.jpg'
import _imports_3 from '../../../assets/images/user/user6.jpg'
import _imports_4 from '../../../assets/images/user/user7.jpg'
import _imports_5 from '../../../assets/images/user/user2.jpg'


const _hoisted_1 = { class: "row" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"col-lg-3\"><div class=\"card mb-25 border-0 rounded-0 bg-white letter-spacing contact-information-card\"><div class=\"card-head\"><h5 class=\"card-title lh-1 fw-semibold mb-0 text-muted\">Filters</h5></div><div class=\"card-body\"><form><div class=\"form-group mb-15 mb-md-20\"><label class=\"d-block text-black fw-semibold mb-10\"> Priority </label><select class=\"form-select shadow-none fw-semibold rounded-0\"><option selected>Urgent</option><option value=\"1\">2</option><option value=\"2\">3</option><option value=\"3\">4</option></select></div><div class=\"form-group mb-15 mb-md-20\"><label class=\"d-block text-black fw-semibold mb-10\">Source</label><select class=\"form-select shadow-none fw-semibold rounded-0\"><option selected>Instagram</option><option value=\"1\">2</option><option value=\"2\">3</option><option value=\"3\">4</option></select></div><div class=\"form-group mb-15 mb-md-20\"><label class=\"d-block text-black fw-semibold mb-10\">Status</label><select class=\"form-select shadow-none fw-semibold rounded-0\"><option selected>Recent</option><option value=\"1\">2</option><option value=\"2\">3</option><option value=\"3\">4</option></select></div><div class=\"form-group mb-15 mb-md-20\"><label class=\"d-block text-black fw-semibold mb-10\">Group</label><select class=\"form-select shadow-none fw-semibold rounded-0\"><option selected>Billing</option><option value=\"1\">2</option><option value=\"2\">3</option><option value=\"3\">4</option></select></div><div class=\"form-group mb-15 mb-md-20\"><label class=\"d-block text-black fw-semibold mb-10\">Agent</label><select class=\"form-select shadow-none fw-semibold rounded-0\"><option selected>Jonathon Ronan</option><option value=\"1\">2</option><option value=\"2\">3</option><option value=\"3\">4</option></select></div><div class=\"form-group\"><label class=\"d-block text-black fw-semibold mb-10\"> Category </label><select class=\"form-select shadow-none fw-semibold rounded-0\"><option selected>None</option><option value=\"1\">2</option><option value=\"2\">3</option><option value=\"3\">4</option></select></div></form></div></div></div>", 1)
const _hoisted_3 = { class: "col-lg-9" }
const _hoisted_4 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing ticket-grid-box" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"card-head box-shadow bg-white d-md-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25\"><form class=\"search-box position-relative\"><input type=\"text\" class=\"form-control shadow-none text-black rounded-0 border-0\" placeholder=\"Search ticket\"><button type=\"submit\" class=\"bg-transparent text-primary transition p-0 border-0\"><i class=\"flaticon-search-interface-symbol\"></i></button></form><div class=\"d-sm-flex align-items-center\"><a href=\"javascript:void(0);\" class=\"default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mt-10 mt-md-0 text-decoration-none\"> Add New Ticket <i class=\"flaticon-plus position-relative ms-5 fs-12\"></i></a><button class=\"default-outline-btn position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-transparent fs-md-15 fs-lg-16 d-inline-block mt-10 mt-md-0\" type=\"button\"> Export <i class=\"flaticon-file-1 position-relative ms-5 top-2 fs-15\"></i></button></div></div>", 1)
const _hoisted_6 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_7 = { class: "item transition" }
const _hoisted_8 = { class: "d-md-flex align-items-center justify-content-between" }
const _hoisted_9 = { class: "d-sm-flex" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "form-check mb-0" }, [
  /*#__PURE__*/_createElementVNode("input", {
    class: "form-check-input shadow-none",
    type: "checkbox"
  })
], -1)
const _hoisted_11 = { class: "mt-10 mt-sm-0 ms-sm-8" }
const _hoisted_12 = { class: "d-sm-flex mb-8" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "badge text-outline-success mt-10 mt-sm-0 ms-sm-10" }, "Recent", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center ms-5 fs-md-15 fs-lg-16" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "rounded-circle me-8",
    width: "24",
    height: "24",
    alt: "user"
  }),
  /*#__PURE__*/_createTextVNode(" Jacky Ronan "),
  /*#__PURE__*/_createElementVNode("span", { class: "fs-12 text-muted fw-medium ms-8" }, "2 days ago")
], -1)
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex align-items-center mt-10 mt-md-0\"><span class=\"lh-1 fw-medium text-danger me-15 me-sm-20 me-md-25 me-lg-30\">Urgent</span><select class=\"form-select shadow-none rounded-0 fs-md-15 fs-lg-16 fw-medium\"><option selected>J. Linowiski</option><option value=\"1\">Z. White</option><option value=\"2\">C. Benden</option><option value=\"3\">A. Smith</option></select></div>", 1)
const _hoisted_16 = { class: "item transition" }
const _hoisted_17 = { class: "d-md-flex align-items-center justify-content-between" }
const _hoisted_18 = { class: "d-sm-flex" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "form-check mb-0" }, [
  /*#__PURE__*/_createElementVNode("input", {
    class: "form-check-input shadow-none",
    type: "checkbox"
  })
], -1)
const _hoisted_20 = { class: "mt-10 mt-sm-0 ms-sm-8" }
const _hoisted_21 = { class: "d-sm-flex mb-8" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "badge text-outline-danger mt-10 mt-sm-0 ms-sm-10" }, "Overdue", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center ms-5 fs-md-15 fs-lg-16" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "rounded-circle me-8",
    width: "24",
    height: "24",
    alt: "user"
  }),
  /*#__PURE__*/_createTextVNode(" Victor James "),
  /*#__PURE__*/_createElementVNode("span", { class: "fs-12 text-muted fw-medium ms-8" }, "3 days ago")
], -1)
const _hoisted_24 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex align-items-center mt-10 mt-md-0\"><span class=\"lh-1 fw-medium text-primary me-15 me-sm-20 me-md-25 me-lg-30\">High</span><select class=\"form-select shadow-none rounded-0 fs-md-15 fs-lg-16 fw-medium\"><option>J. Linowiski</option><option value=\"1\" selected>Z. White</option><option value=\"2\">C. Benden</option><option value=\"3\">A. Smith</option></select></div>", 1)
const _hoisted_25 = { class: "item transition" }
const _hoisted_26 = { class: "d-md-flex align-items-center justify-content-between" }
const _hoisted_27 = { class: "d-sm-flex" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "form-check mb-0" }, [
  /*#__PURE__*/_createElementVNode("input", {
    class: "form-check-input shadow-none",
    type: "checkbox"
  })
], -1)
const _hoisted_29 = { class: "mt-10 mt-sm-0 ms-sm-8" }
const _hoisted_30 = { class: "d-sm-flex mb-8" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", { class: "badge text-outline-info mt-10 mt-sm-0 ms-sm-10" }, " Remaining ", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center ms-5 fs-md-15 fs-lg-16" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    class: "rounded-circle me-8",
    width: "24",
    height: "24",
    alt: "user"
  }),
  /*#__PURE__*/_createTextVNode(" Angela Carter "),
  /*#__PURE__*/_createElementVNode("span", { class: "fs-12 text-muted fw-medium ms-8" }, "4 days ago")
], -1)
const _hoisted_33 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex align-items-center mt-10 mt-md-0\"><span class=\"lh-1 fw-medium text-info me-15 me-sm-20 me-md-25 me-lg-30\">Medium</span><select class=\"form-select shadow-none rounded-0 fs-md-15 fs-lg-16 fw-medium\"><option>J. Linowiski</option><option value=\"1\">Z. White</option><option value=\"2\" selected>C. Benden</option><option value=\"3\">A. Smith</option></select></div>", 1)
const _hoisted_34 = { class: "item transition" }
const _hoisted_35 = { class: "d-md-flex align-items-center justify-content-between" }
const _hoisted_36 = { class: "d-sm-flex" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "form-check mb-0" }, [
  /*#__PURE__*/_createElementVNode("input", {
    class: "form-check-input shadow-none",
    type: "checkbox"
  })
], -1)
const _hoisted_38 = { class: "mt-10 mt-sm-0 ms-sm-8" }
const _hoisted_39 = { class: "d-sm-flex mb-8" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", { class: "badge text-outline-primary mt-10 mt-sm-0 ms-sm-10" }, "Responded", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center ms-5 fs-md-15 fs-lg-16" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    class: "rounded-circle me-8",
    width: "24",
    height: "24",
    alt: "user"
  }),
  /*#__PURE__*/_createTextVNode(" Bretlon White "),
  /*#__PURE__*/_createElementVNode("span", { class: "fs-12 text-muted fw-medium ms-8" }, "2 days ago")
], -1)
const _hoisted_42 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex align-items-center mt-10 mt-md-0\"><span class=\"lh-1 fw-medium text-danger me-15 me-sm-20 me-md-25 me-lg-30\">Urgent</span><select class=\"form-select shadow-none rounded-0 fs-md-15 fs-lg-16 fw-medium\"><option>J. Linowiski</option><option value=\"1\">Z. White</option><option value=\"2\">C. Benden</option><option value=\"3\" selected>A. Smith</option></select></div>", 1)
const _hoisted_43 = { class: "item transition" }
const _hoisted_44 = { class: "d-md-flex align-items-center justify-content-between" }
const _hoisted_45 = { class: "d-sm-flex" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "form-check mb-0" }, [
  /*#__PURE__*/_createElementVNode("input", {
    class: "form-check-input shadow-none",
    type: "checkbox"
  })
], -1)
const _hoisted_47 = { class: "mt-10 mt-sm-0 ms-sm-8" }
const _hoisted_48 = { class: "d-sm-flex mb-8" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("span", { class: "badge text-outline-muted mt-10 mt-sm-0 ms-sm-10" }, "Closed", -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center ms-5 fs-md-15 fs-lg-16" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    class: "rounded-circle me-8",
    width: "24",
    height: "24",
    alt: "user"
  }),
  /*#__PURE__*/_createTextVNode(" Sam Smith "),
  /*#__PURE__*/_createElementVNode("span", { class: "fs-12 text-muted fw-medium ms-8" }, "3 days ago")
], -1)
const _hoisted_51 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex align-items-center mt-10 mt-md-0\"><span class=\"lh-1 fw-medium text-warning me-15 me-sm-20 me-md-25 me-lg-30\">Low</span><select class=\"form-select shadow-none rounded-0 fs-md-15 fs-lg-16 fw-medium\"><option selected>J. Linowiski</option><option value=\"1\">Z. White</option><option value=\"2\">C. Benden</option><option value=\"3\">A. Smith</option></select></div>", 1)
const _hoisted_52 = { class: "item transition" }
const _hoisted_53 = { class: "d-md-flex align-items-center justify-content-between" }
const _hoisted_54 = { class: "d-sm-flex" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "form-check mb-0" }, [
  /*#__PURE__*/_createElementVNode("input", {
    class: "form-check-input shadow-none",
    type: "checkbox"
  })
], -1)
const _hoisted_56 = { class: "mt-10 mt-sm-0 ms-sm-8" }
const _hoisted_57 = { class: "d-sm-flex mb-8" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("span", { class: "badge text-outline-success mt-10 mt-sm-0 ms-sm-10" }, " Recent ", -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center ms-5 fs-md-15 fs-lg-16" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_5,
    class: "rounded-circle me-8",
    width: "24",
    height: "24",
    alt: "user"
  }),
  /*#__PURE__*/_createTextVNode(" Victoria Carter "),
  /*#__PURE__*/_createElementVNode("span", { class: "fs-12 text-muted fw-medium ms-8" }, "3 days ago")
], -1)
const _hoisted_60 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex align-items-center mt-10 mt-md-0\"><span class=\"lh-1 fw-medium text-danger me-15 me-sm-20 me-md-25 me-lg-30\">Urgent</span><select class=\"form-select shadow-none rounded-0 fs-md-15 fs-lg-16 fw-medium\"><option>J. Linowiski</option><option value=\"1\">Z. White</option><option value=\"2\">C. Benden</option><option value=\"3\" selected>A. Smith</option></select></div>", 1)
const _hoisted_61 = /*#__PURE__*/_createStaticVNode("<div class=\"pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center\"><p class=\"mb-0 text-paragraph\"> Showing <span class=\"fw-bold\">06</span> out of <span class=\"fw-bold\">13</span> results </p><nav class=\"mt-15 mt-md-0\"><ul class=\"pagination mb-0\"><li class=\"page-item\"><a class=\"page-link\" href=\"#\" aria-label=\"Previous\"><i class=\"flaticon-chevron-1\"></i></a></li><li class=\"page-item\"><a class=\"page-link active\" href=\"#\">1</a></li><li class=\"page-item\"><a class=\"page-link\" href=\"#\">2</a></li><li class=\"page-item\"><a class=\"page-link\" href=\"#\">3</a></li><li class=\"page-item\"><a class=\"page-link\" href=\"#\" aria-label=\"Next\"><i class=\"flaticon-chevron\"></i></a></li></ul></nav></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_router_link, {
                      to: "/ticket-preview",
                      class: "d-block text-decoration-none fw-medium fs-md-16 fs-lg-16"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" CESPT Dashboard Design #Ticket 1436 ")
                      ]),
                      _: 1
                    }),
                    _hoisted_13
                  ]),
                  _hoisted_14
                ])
              ]),
              _hoisted_15
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_router_link, {
                      to: "/ticket-previewl",
                      class: "d-block text-decoration-none fw-medium fs-md-16 fs-lg-16"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Higher Calculus App Design #Ticket 2098 ")
                      ]),
                      _: 1
                    }),
                    _hoisted_22
                  ]),
                  _hoisted_23
                ])
              ]),
              _hoisted_24
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _createVNode(_component_router_link, {
                      to: "/ticket-previewl",
                      class: "d-block text-decoration-none fw-medium fs-md-16 fs-lg-16"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" CESPT Admin Issue #Ticket 3465 ")
                      ]),
                      _: 1
                    }),
                    _hoisted_31
                  ]),
                  _hoisted_32
                ])
              ]),
              _hoisted_33
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _hoisted_37,
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, [
                    _createVNode(_component_router_link, {
                      to: "/ticket-previewl",
                      class: "d-block text-decoration-none fw-medium fs-md-16 fs-lg-16"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Email Submission Issue #Ticket 2345 ")
                      ]),
                      _: 1
                    }),
                    _hoisted_40
                  ]),
                  _hoisted_41
                ])
              ]),
              _hoisted_42
            ])
          ]),
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("div", _hoisted_45, [
                _hoisted_46,
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("div", _hoisted_48, [
                    _createVNode(_component_router_link, {
                      to: "/ticket-previewl",
                      class: "d-block text-decoration-none fw-medium fs-md-16 fs-lg-16"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" CESPT Dashboard Design #Ticket 1436 ")
                      ]),
                      _: 1
                    }),
                    _hoisted_49
                  ]),
                  _hoisted_50
                ])
              ]),
              _hoisted_51
            ])
          ]),
          _createElementVNode("div", _hoisted_52, [
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("div", _hoisted_54, [
                _hoisted_55,
                _createElementVNode("div", _hoisted_56, [
                  _createElementVNode("div", _hoisted_57, [
                    _createVNode(_component_router_link, {
                      to: "/ticket-previewl",
                      class: "d-block text-decoration-none fw-medium fs-md-16 fs-lg-16"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Email Submission Issue #Ticket 2345 ")
                      ]),
                      _: 1
                    }),
                    _hoisted_58
                  ]),
                  _hoisted_59
                ])
              ]),
              _hoisted_60
            ])
          ]),
          _hoisted_61
        ])
      ])
    ])
  ]))
}